<template>

  <div>
    <div class="window-header">
      <h3 class="title">Depositar a Cuenta Virtual</h3>
      <button class="button-close" @click="$modal.hide('virtualaccounts-credits')">×</button>
    </div>
    <div class="modal-content">
      <p>Tu saldo actual: <b>{{ formatCurrency($store.getters.getUserBalance.balance) }}</b></p>
      <div v-if="$store.getters.getUserClabe">
        <h3 class="title">Datos para transferencia bancaria:</h3>
        <div class="bank-details">
          <pre><code>{{ $store.getters.getFullUserName }}
  RFC: {{ $store.getters.getUserRFC }}
  Banco: {{ bank }}
  CLABE: {{ $store.getters.getUserClabe }}
  Email {{ email }}
          </code></pre>
        </div>
        <p class="-legend">* Las transferencias deben venir de una cuenta a tu nombre, no aceptamos transferencias de terceros.</p>
      </div>
      <div v-else>
        <h3 class="title">Tu cuenta aún no ha sido habilitada.</h3>
        <br>
      </div>
      <div class="modal-investment-buttons">
        <button class="button" @click="$modal.hide('virtualaccounts-credits')">Cerrar</button>
      </div>
    </div>
  </div>

</template>

<script>
import mixins from '@/mixins/index'

export default {
  name: 'DashboardVirtualAccountsModalCredit',
  data () {
    return {
      business: process.env.BUSINESS_NAME,
      bank: process.env.BUSINESS_BANK,
      email: process.env.BUSINESS_EMAIL
    }
  },
  mixins: [mixins],
  created: function () {
    this.getInvestorClabe()
    this.getUserData()
  }
}

</script>



// WEBPACK FOOTER //
// src/views/dashboardVirtualAccount/DashboardVirtualAccountsModalCredit.vue